import style from './style.styl'
import {
  StartDate,
  Form,
  Building,
  Intro,
  What,
  Who,
  Apply,
  Advisors,
  Experts,
  Feedback,
  LogosRow, ApplyButton, Faq, FooterNew
} from '../../components'

const Home = () => (
  <div className={style.home}>
    <Intro />
    <What />
    <Experts />
    <Advisors />
    <Who />
    <LogosRow />
    <Feedback />
    <div className={style.applyButtonWrap}><ApplyButton /></div>
    <Building />
    <StartDate />
    <Apply />
    <Form />
    <Faq />
    <FooterNew />
  </div>
)

export default Home



// WEBPACK FOOTER //
// ./routes/home/index.js